module.exports = __webpack_public_path__ + "static/media/Platinum-Host-NA-Partner.bd332b99.png";